import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { PaymentsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createPayment = (data): any => action(types.CREATE_PAYMENT_REQUESTED, data);

export const updatePayment = (data): any => action(types.UPDATE_PAYMENT_REQUESTED, data);

export const deletePayment = (paymentId): any => action(types.UPDATE_PAYMENT_REQUESTED, paymentId);

export const getPayment = (paymentId): any => action(types.GET_PAYMENT_REQUESTED, paymentId);

export const getAllPayments = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_PAYMENTS_REQUESTED, { pagination, compile });

export const selectPayment = (paymentId): any => action(types.SELECT_PAYMENT_REQUESTED, { currentPaymentId: paymentId });

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createPaymentPending: (payload): any => action(types.CREATE_PAYMENT_PENDING, payload),
  createPaymentSuccess: (response): any => action(types.CREATE_PAYMENT_SUCCESS, {
    paymentsById: response.entities.payments,
    currentPaymentId: response.result,
  }),
  updatePaymentPending: (payload): any => action(types.UPDATE_PAYMENT_PENDING, payload),
  updatePaymentSuccess: (response): any => action(types.UPDATE_PAYMENT_SUCCESS, {
    paymentsById: response.entities.payments,
    currentPaymentId: response.result,
  }),
  updatePaymentFailed: (error): any => action(types.UPDATE_PAYMENT_FAIL, { backendErrors: error }),
  deletePaymentPending: (): any => action(types.UPDATE_PAYMENT_PENDING, {}),
  deletePaymentSuccess: (response, userId): any => {
    localStorage.set(userId, { currentPaymentId: null });
    history.push('/payments');

    return action(types.DELETE_PAYMENT_SUCCESS, {
      currentPaymentId: response,
    });
  },
  getPaymentPending: (): any => action(types.GET_PAYMENT_PENDING, {}),
  getPaymentSuccess: (response): any => action(types.GET_PAYMENT_SUCCESS, {
    paymentsById: response.entities.payments,
    currentPaymentId: response.result,
  }),
  getPaymentFailed: (error): any => action(types.GET_PAYMENT_FAIL, { backendErrors: error }),
  deletePaymentFailed: (error): any => action(types.UPDATE_PAYMENT_FAIL, { backendErrors: error }),
  getAllPaymentsPending: (pagination): any => action(types.GET_ALL_PAYMENTS_PENDING, { pagination }),
  getAllPaymentsSuccess: (response, meta): any => action(types.GET_ALL_PAYMENTS_SUCCESS, {
    paymentsById: response.entities.payments,
    paymentIds: response.result,
    meta,
  }),
  getAllPaymentsFailed: (error): any => action(types.GET_ALL_PAYMENTS_FAIL, { backendErrors: error }),
  createPaymentFailed: (error): any => action(types.CREATE_PAYMENT_FAIL, { backendErrors: error }),
};

export default null;
